export const GET_WAITLIST_DATA_PENDING = 'GET_WAITLIST_DATA_PENDING'
export const GET_WAITLIST_DATA_COMPLETED = 'GET_WAITLIST_DATA_COMPLETED'
export const GET_WAITLIST_DATA_REJECTED = 'GET_WAITLIST_DATA_REJECTED'
export const SELECT_TURN = 'SELECT_TURN'
export const SET_SELECTED_HISTORY_TURN = 'SET_SELECTED_HISTORY_TURN'
export const SET_HISTORY_FILTER = 'SET_HISTORY_FILTER'
export const SORT_WAITLIST_ORDER_PENDING = 'SORT_WAITLIST_ORDER_PENDING'
export const SORT_WAITLIST_ORDER_COMPLETED = 'SORT_WAITLIST_ORDER_COMPLETED'
export const SORT_WAITLIST_ORDER_REJECTED = 'SORT_WAITLIST_ORDER_REJECTED'
